import { useState, useEffect } from 'react';
import axios from 'axios';
import TextField from '@mui/material/TextField';

const Box = ({ label, value, count }) => (
    <div className="bg-white rounded-lg shadow-sm p-4 flex flex-col gap-1">
        <span className="text-xs text-gray-500 uppercase">{label}</span>
        <span className="text-2xl font-semibold text-primary-green">HK${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
        <span className="text-xs text-gray-400">{count} order{count !== 1 ? "s" : ""}</span>
    </div>
);

const NetSalesBoxes = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const fetchData = async (from, to) => {
        setLoading(true);
        try {
            const params = {};
            if (from && to) { params.from = from; params.to = to; }
            const { data } = await axios.get('/api/v1/admin/dashboard/net-sales', { params });
            setData(data);
        } catch (error) {
            console.error('Failed to load net sales', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const applyCustomRange = () => {
        if (!fromDate || !toDate) return;
        fetchData(fromDate, toDate);
    };

    const clearCustomRange = () => {
        setFromDate("");
        setToDate("");
        fetchData();
    };

    return (
        <div className="bg-white rounded-xl shadow-lg p-5 flex flex-col gap-4">
            <div className="flex flex-wrap justify-between items-center gap-3">
                <h2 className="font-medium text-lg">Net Sales</h2>
                <div className="flex items-center gap-2">
                    <TextField
                        type="date"
                        size="small"
                        label="From"
                        InputLabelProps={{ shrink: true }}
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                    />
                    <TextField
                        type="date"
                        size="small"
                        label="To"
                        InputLabelProps={{ shrink: true }}
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                    />
                    <button onClick={applyCustomRange} className="bg-primary-blue text-white text-sm px-4 py-2 rounded shadow hover:shadow-lg">Apply</button>
                    {data?.custom && (
                        <button onClick={clearCustomRange} className="text-sm text-gray-500 px-2">Clear</button>
                    )}
                </div>
            </div>

            {loading || !data ? (
                <p className="text-sm text-gray-400">Loading...</p>
            ) : (
                <div className={`grid grid-cols-2 ${data.custom ? "sm:grid-cols-5" : "sm:grid-cols-4"} gap-4`}>
                    <Box label="Today" value={data.today.total} count={data.today.count} />
                    <Box label="Yesterday" value={data.yesterday.total} count={data.yesterday.count} />
                    <Box label="This Week" value={data.thisWeek.total} count={data.thisWeek.count} />
                    <Box label="This Month" value={data.thisMonth.total} count={data.thisMonth.count} />
                    {data.custom && (
                        <Box label="Custom Range" value={data.custom.total} count={data.custom.count} />
                    )}
                </div>
            )}
        </div>
    );
};

export default NetSalesBoxes;